module.exports = __webpack_public_path__ + "img/adia_logo.e5e72ee0.jpeg";